export const CONFIG = {
  host: {
    staging: 'https://pk7napwge5.execute-api.eu-central-1.amazonaws.com/stg',
    production: 'https://pk7napwge5.execute-api.eu-central-1.amazonaws.com/prod'
  }
};



// WEBPACK FOOTER //
// ./src/app/api/api.config.ts